<template>
  <div class="dummy">
    <div class="col-md-12">
      <button type="button" @click="dashboardMenu('sendMoney')">Send Money</button>
    </div>
    <div class="col-md-12" style="margin-top:10px">
      <button type="button" @click="dashboardMenu('payBills')">Pay Bills</button>
    </div>
    <div class="col-md-12" style="margin-top:10px">
      <button type="button" @click="dashboardMenu('payQR')">Pay QR</button>
    </div>
    <div class="col-md-12" style="margin-top:10px">
      <button type="button" @click="dashboardMenu('saveMoney')">Save Money</button>
    </div>
    <div class="col-md-12" style="margin-top:10px">
      <button type="button" @click="dashboardMenu('referral')">Referral</button>
    </div>
    <div class="col-md-12" style="margin-top:10px">
      <button type="button" @click="dashboardMenu('help')">Help</button>
    </div>
    <div class="col-md-12" style="margin-top:10px">
      <button type="button" @click="dashboardMenu('vouchers')">Vouchers</button>
    </div>
    <div class="col-md-12" style="margin-top:10px">
      <button type="button" @click="onboardingResult('registration')">Registration Success</button>
    </div>
    <div class="col-md-12" style="margin-top:10px">
      <button type="button" @click="onboardingResult('link')">Link Success</button>
    </div>
    <div class="col-md-12" style="margin-top:10px">
      <button type="button" @click="useVoucher()">Use Voucher</button>
    </div>
    <div class="col-md-12" style="margin-top:10px">
      <button type="button" @click="dashboardUnlink()">Unlink</button>
    </div>
    <div class="col-md-12" style="margin-top:10px">
      <button type="button" @click="relink()">Relink Success</button>
    </div>
    <div class="col-md-12" style="margin-top:10px">
      <button type="button" @click="buyLoad()">Buy Load Success</button>
    </div>
    <div class="col-md-12" style="margin-top:10px">
      <button type="button" @click="dashboardMenu('cashOut')">Trigger Cash Out</button>
    </div>
    <div class="col-md-12" style="margin-top:10px">
      <button type="button" @click="dashboardMenu('cashIn')">Trigger Cash In</button>
    </div>
    <div>
      Debug: {{ debug }}
      Thread Context: {{ threadContext }}
      User ID: {{ userID }}
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'App',
  data () {
    return {
      url: 'https://gcm-chat-service.aiah.ai/',
      debug: 'HAHA',
      appID: '717995625387159',
      threadContext: '',
      userID: ''
    }
  },
  mounted () {
    window.extAsyncInit = function () {
      // the Messenger Extensions JS SDK is done loading
      console.log('LOADED')
    }
  },
  methods: {
    dashboardMenu: function (type) {
      const _this = this

      // eslint-disable-next-line
      MessengerExtensions.getContext(_this.appID,
        function success (threadContext) {
          axios({
            method: 'post',
            url: _this.url + 'dashboard/menu',
            headers: {'Content-Type': 'application/json'},
            data: {
              psid: threadContext.psid,
              menu_type: type
            }
          }).then(data => {
            if (data.data.success) {
              // eslint-disable-next-line
              MessengerExtensions.requestCloseBrowser(success => {
              }, err => {
                if (err) {

                }
              })
            }
          })

          console.log('THREAD CONTEXT: ', threadContext)
          _this.debug = `${_this.url}dashboard/buy-load`
          _this.threadContext = threadContext
        }, function error (err, data) {
          console.log(err, data)
          if (err) {
            _this.debug = err + '|' + data
          }
        }
      )
    },
    onboardingResult: function (type) {
      const _this = this

      // eslint-disable-next-line
      MessengerExtensions.getContext(_this.appID,
        function success (threadContext) {
          console.log('THREAD CONTEXT: ', threadContext)
          _this.debug = 'SUCCESS'
          _this.debug = `${_this.url}dashboard/buy-load`
          axios({
            method: 'post',
            url: _this.url + 'onboarding/result',
            headers: {'Content-Type': 'application/json'},
            data: {
              psid: threadContext.psid,
              type: type
            }
          }).then(data => {
            if (data.data.success) {
              // eslint-disable-next-line
              MessengerExtensions.requestCloseBrowser(success => {
              }, err => {
                if (err) {

                }
              })
            }
          })
        }, function error (err, data) {
          console.log(err, data)
          if (err) {
            _this.debug = err + '|' + data
          }
        }
      )
    },
    useVoucher: function () {
      const _this = this

      // eslint-disable-next-line
      MessengerExtensions.getContext(_this.appID,
        function success (threadContext) {
          console.log('THREAD CONTEXT: ', threadContext)
          _this.debug = 'SUCCESS'
          _this.debug = `${_this.url}dashboard/buy-load`
          axios({
            method: 'post',
            url: _this.url + 'onboarding/use-voucher',
            headers: {'Content-Type': 'application/json'},
            data: {
              psid: threadContext.psid
            }
          }).then(data => {
            if (data.data.success) {
              // eslint-disable-next-line
              MessengerExtensions.requestCloseBrowser(success => {
              }, err => {
                if (err) {

                }
              })
            }
          })
        }, function error (err, data) {
          console.log(err, data)
          if (err) {
            _this.debug = err + '|' + data
          }
        }
      )
    },
    dashboardUnlink: function () {
      const _this = this

      // eslint-disable-next-line
      MessengerExtensions.getContext(_this.appID,
        function success (threadContext) {
          console.log('THREAD CONTEXT: ', threadContext)
          _this.debug = 'SUCCESS'
          _this.debug = `${_this.url}dashboard/buy-load`
          axios({
            method: 'post',
            url: _this.url + 'dashboard/unlink',
            headers: {'Content-Type': 'application/json'},
            data: {
              psid: threadContext.psid
            }
          }).then(data => {
            if (data.data.success) {
              // eslint-disable-next-line
              MessengerExtensions.requestCloseBrowser(success => {
              }, err => {
                if (err) {

                }
              })
            }
          })
        }, function error (err, data) {
          console.log(err, data)
          if (err) {
            _this.debug = err + '|' + data
          }
        }
      )
    },
    relink: function () {
      const _this = this

      // eslint-disable-next-line
      MessengerExtensions.getContext(_this.appID,
        function success (threadContext) {
          console.log('THREAD CONTEXT: ', threadContext)
          _this.debug = 'SUCCESS'
          _this.debug = `${_this.url}dashboard/buy-load`
          axios({
            method: 'post',
            url: _this.url + 'onboarding/relink',
            headers: {'Content-Type': 'application/json'},
            data: {
              psids: [threadContext.psid],
              type: 'success'
            }
          }).then(data => {
            if (data.data.success) {
              // eslint-disable-next-line
              MessengerExtensions.requestCloseBrowser(success => {
              }, err => {
                if (err) {

                }
              })
            }
          }).catch(err => console.log(err))
        }, function error (err, data) {
          console.log(err, data)
          if (err) {
            _this.debug = err + '|' + data
          }
        }
      )
    },
    buyLoad () {
      const _this = this

      // eslint-disable-next-line
      MessengerExtensions.getContext(_this.appID,
        function success (threadContext) {
          console.log('THREAD CONTEXT: ', threadContext)
          _this.debug = 'SUCCESS'
          _this.debug = `${_this.url}dashboard/buy-load`
          axios.post(`${_this.url}dashboard/buy-load`, {
            psid: threadContext.psid,
            transaction_details: {
              purchased_load: 'GoSurf100',
              discount: '10.00',
              total_amount: '50.00',
              reference_number: '1234567890',
              mobile_number_ending_digits: '1234'
            }
          }).then(data => {
            _this.debug = 'A: ' + threadContext.psid

            if (data.data.success) {
              // eslint-disable-next-line
              MessengerExtensions.requestCloseBrowser(success => {
              }, err => {
                if (err) {

                }
              })
            }
          }).catch(err => {
            if (err) {
              _this.debug = 'ERROR: ' + err
            }
          })
        }, function error (err, data) {
          console.log(err, data)
          if (err) {
            _this.debug = err + '|' + data
          }
        }
      )
    }
  }
}
</script>

<style scoped>
.dummy {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dummy.vue